<div class="dias-semana" role="group" aria-label="Dias da semana">
  @for (dia of diasDisponiveis; track dia) {
    <button
      type="button"
      class="chip-dia"
      [class.chip-dia--selecionado]="estaSelecionado(dia)"
      [attr.aria-pressed]="estaSelecionado(dia)"
      [disabled]="disabled"
      (click)="alternarDia(dia)">
      {{ labels[dia] }}
    </button>
  }
</div>
